import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-empty-screen',
  templateUrl: './empty-screen.component.html',
  styleUrls: ['./empty-screen.component.scss']
})
export class EmptyScreenComponent {
  @Input() icon: string = 'fa-inbox';  // Default icon
  @Input() message: string = 'No items found';  // Default message
  @Input() subMessage?: string;  // Optional sub-message
  @Input() showAction: boolean = false;  // Whether to show action button
  @Input() actionLabel: string = 'Add New';  // Default action button label
  @Output() onActionClick = new EventEmitter<void>();
  
  // Event emitter for action button click
  handleActionClick(): void {
    this.onActionClick.emit();
  }
} 